import { Card, CardContent } from "../ui/card";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { CheckCircle2, XCircle, AlertTriangle, Download, ShieldCheck } from "lucide-react";

export const SaftValidationCard = ({ validation, validating, onValidate, onExport }) => (
  <Card className={validation ? (validation.xsd_valid ? "border-emerald-500/40" : "border-red-500/40") : ""} data-testid="saft-validation-card">
    <CardContent className="p-4 space-y-3">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <ShieldCheck className="w-6 h-6 text-primary" />
          <div>
            <p className="font-semibold">Ficheiro SAF-T (AO) v1.01_01</p>
            <p className="text-sm text-muted-foreground">Validado contra o esquema oficial (SAFTAO1.01_01.xsd) antes de ser entregue à AGT</p>
          </div>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={onValidate} disabled={validating} data-testid="saft-validate-btn">
            {validating ? "A validar…" : "Validar período"}
          </Button>
          <Button onClick={onExport} className="gap-2" data-testid="saft-export-btn">
            <Download className="w-4 h-4" /> Exportar XML
          </Button>
        </div>
      </div>

      {validation && (
        <div className="space-y-2" data-testid="saft-validation-result">
          <div className="flex items-center gap-2">
            {validation.xsd_valid ? <CheckCircle2 className="w-5 h-5 text-emerald-500" /> : <XCircle className="w-5 h-5 text-red-500" />}
            <span className="font-medium">{validation.xsd_valid ? "XML válido segundo o XSD oficial" : "XML inválido — corrija antes de entregar"}</span>
            <Badge variant="outline" className="ml-auto font-mono text-xs">{validation.filename}</Badge>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-2 text-sm">
            {Object.entries(validation.counts || {}).map(([k, v]) => (
              <div key={k} className="p-2 rounded bg-muted/50 text-center">
                <p className="text-lg font-bold">{v}</p>
                <p className="text-xs text-muted-foreground capitalize">{k.replace("_", " ")}</p>
              </div>
            ))}
          </div>
          {(validation.xsd_errors || []).map((e, i) => (
            <p key={i} className="text-xs text-red-500 font-mono break-all">{e}</p>
          ))}
          {(validation.issues || []).map((w, i) => (
            <p key={i} className="text-xs text-amber-600 flex items-start gap-1"><AlertTriangle className="w-3 h-3 mt-0.5 shrink-0" />{w}</p>
          ))}
          {validation.chain_ok === true && <p className="text-xs text-emerald-600 flex items-center gap-1"><CheckCircle2 className="w-3 h-3" /> Cadeia de assinaturas íntegra em todas as séries</p>}
        </div>
      )}
    </CardContent>
  </Card>
);
